import React, { useState } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';

interface Props {
    onExpandedChange?: (expanded: boolean) => void;
}

const HudAccordion = (props: React.PropsWithChildren<Props>) => {
    const [expanded, setExpanded] = useState(true);

    const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded);
        props.onExpandedChange?.(isExpanded);
    };

    return (
        <Accordion expanded={expanded} onChange={handleChange}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                HUD
            </AccordionSummary>
            <AccordionDetails>
                <Grid spacing={1} container>
                    {props.children}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default HudAccordion;
